import { defineComponent as _defineComponent } from 'vue'
import { useFamilySearch } from '@/composables/use-family-search';


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyPatentsLoading',
  setup(__props) {

const { isFamilySearchFromWorkspace } = useFamilySearch();

return { __sfc: true,isFamilySearchFromWorkspace }
}

})